import React, { Component } from 'react'
import prepareComponent from 'client/shared/decorators/prepare-component'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import urlFor from 'shared/tools/url-helper'

import MetaTitle from 'client/shared/blocks/meta-title'
import Meta from 'client/shared/blocks/meta'
import MetaDeeplink from 'client/shared/blocks/meta-deeplink'

import {
  buildUser,
  load,
  loadRecent,
  loadCounters,
  loadShelves,
} from 'client/bookmate/reducers/user-reducer'
import { SHELVES_LIMIT } from '../boxes/user-shelves-box'
import { State } from 'shared/types/redux'

type Props = {
  user: { name: string; login: string }
}

class UserPage extends Component<Props> {
  render() {
    return (
      <>
        {this.renderMeta()}
        {this.props.children}
      </>
    )
  }

  renderMeta() {
    const {
      user: { name = '', login = '' },
    } = this.props

    return (
      <>
        <MetaTitle title={`${name || ''} (@${login})`} />
        <MetaDeeplink target="user" uuid={login} />
        <Meta
          content={urlFor.canvasUser({ username: login, mode: 'twitter' })}
          property="twitter:image"
        />
        <Meta
          content={urlFor.canvasUser({ username: login, mode: 'facebook' })}
          property="og:image"
        />
        <Meta name="robots" content="noindex, follow" />
      </>
    )
  }
}

const prepareWrapper = prepareComponent(
  // eslint-disable-next-line func-names
  async function ({ store, params }) {
    const { username = '' } = params
    const { dispatch } = store
    const actions = [
      dispatch(load(username)),
      dispatch(loadRecent(username)),
      dispatch(loadCounters(username)),
      dispatch(loadShelves(username, 1, SHELVES_LIMIT)),
    ]
    await Promise.all(actions)
  },
  {
    updateParams: 'username',
    userListener: true,
  },
)

const connectWrapper = connect((state: State) => ({
  user: buildUser(state, state.user.login),
}))

const wrappers = compose(prepareWrapper, connectWrapper)

export default wrappers(UserPage)
